import TagDiscussionModal from 'flarum/tags/components/TagDiscussionModal';

export default class KnowledgeBaseTagModal extends TagDiscussionModal {
  className() {
    return 'TagDiscussionModal KnowledgeBaseTagSelector';
  }
}
